export enum AnalyzeMeterReadingType {
  SupplyTemp = 'SupplyTemp',
  ReturnTemp = 'ReturnTemp',
  Evmrt = 'Evmrt',
  OutdoorTemp = 'OutdoorTemp',
  Humidity = 'Humidity',
  PowerCost = 'PowerCost',
  Other = 'Other',
  Services = 'Services',
  EnergyCost = 'EnergyCost',
  Bonus = 'Bonus',
  Energy = 'Energy',
  NormalAdjusted = 'NormalAdjusted'
}
